module.exports = __webpack_public_path__ + "static/media/retirement-object-1-0-0.805e7cad.png";